import { takeUntil } from 'rxjs/operators';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { MasterDataEditService } from '../../../../../api/master-data-edit.service';
import { AffectingCompanyData } from '../../../../../shared/models/product.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'app-rename-company',
  templateUrl: './rename-company.component.html',
})
export class RenameCompanyComponent implements OnInit {
  @ViewChild('existingCompanyNameGrid') existingCompanyNameGrid: DxDataGridComponent;

  public afftectedCompanyNameData: AffectingCompanyData[] = [];
  public existingCompanyNameData: AffectingCompanyData[] = [];

  @Input() selectedEditCompanyOldName: string;
  @Input() selectedEditCompanyNewName: string;
  @Input() companyId;

  private _destroyed$ = new Subject();

  constructor(private masterDataEditService: MasterDataEditService, public activeModal: NgbActiveModal) { }

  ngOnInit() {
	this.masterDataEditService.getAfftectedCompanyNameData(this.selectedEditCompanyOldName)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res: AffectingCompanyData[]) => {
		this.afftectedCompanyNameData = res;
		});

	this.masterDataEditService.getExistingCompanyNameData(this.selectedEditCompanyNewName)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res: AffectingCompanyData[]) => {
		this.existingCompanyNameData = res;
		});
  }

  rename() {
	this.activeModal.close('save');
  }

  customizeCompanyId(cellInfo) {
	const idStr = 'Cm_000000';
	const cellValue = String(cellInfo.value);
	const index = idStr.length - cellValue.length;
	const finalText = idStr.slice(0, index) + cellValue;
	return finalText;
  }

  valueChanged(event) {
	this.existingCompanyNameGrid.instance.beginCustomLoading('Loading');
	this.masterDataEditService.getExistingCompanyNameData(event.value)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res: AffectingCompanyData[]) => {
		this.existingCompanyNameData = res;
		this.existingCompanyNameGrid.instance.option('dataSource', res);
		this.existingCompanyNameGrid.instance.endCustomLoading();
		});
  }

}
